define.alias("shared/components/shared/post/secondary/caption-writer/header", "media/components/shared/post/secondary/caption-writer/header");